'use client';

import { useState } from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogTrigger,
} from '@/components/ui/dialog';
import { BirthdayForm } from './birthday-form';
import { PlusCircle } from 'lucide-react';

export function AddBirthday() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button>
          <PlusCircle className="mr-2 h-4 w-4" />
          Add Birthday
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add a New Birthday</DialogTitle>
          <DialogDescription>
            Enter the details below to add a new birthday to your calendar.
          </DialogDescription>
        </DialogHeader>
        <BirthdayForm onSuccess={() => setIsOpen(false)} />
      </DialogContent>
    </Dialog>
  );
}
